import {useState} from "react";
import FontAwesome from "../../utilities/FontAwesome";

import classNames from "classnames";
import styles from "./styles/Selector.module.scss";
import useClickOutside from "../../../hooks/useClickOutside";
import {IOption} from "../../utilities/MultiSelect";

const selectedClassName = classNames({
    [styles.selected]: true,
});
const inputClassName = classNames({
    [styles.input]: true,
});

export default function Selector(props: {
    options: IOption[] | {
        [category: string]: IOption[]
    },
    onChange: (value: IOption["value"]) => void,
    value: string,
    className?: string,
    loading?: boolean,
    disabled?: boolean,
}) {
    const [open, setOpen] = useState(false);

    const ref = useClickOutside(() => setOpen(false));

    const selectorContainerClassName = classNames({
        [props.className || ""]: props.className,
        [styles.selectorContainer]: true,
        [styles.selectorContainerLoading]: props.loading,
    });

    const options: React.ReactElement[] = [];
    if (props.loading) {
        options.push(<ul key="loading"><li><FontAwesome name={'fa-spinner'} prefix={'fas'} spin /></li></ul>)
    } else if (Array.isArray(props.options)) {
        options.push(<ul key="array">
            {props.options.map((item) => {
                const listItemClassName = classNames({
                    [styles.listItem]: true,
                    [styles.listItemSelected]: item.title === props.value,
                });
                return <li onClick={() => props.onChange(item.value)} key={item.value}
                           className={listItemClassName}>{item.title}</li>;
            })}
        </ul>)
    } else {
        // allow for an object with sections as keys
        for (let k in props.options) {
            if (props.options.hasOwnProperty(k)) {
                options.push(<>
                    <span className={styles.listItem}>{k}</span>
                    <ul key={k}>
                        {props.options[k].map((item) => {
                            const listItemClassName = classNames({
                                [styles.listItem]: true,
                                [styles.listItemSelected]: item.title === props.value,
                            });

                            return <li onClick={() => props.onChange(item.value)} key={item.value}
                                       className={listItemClassName}>{item.title}</li>;
                        })}
                    </ul>
                </>)
            }
        }
    }

    return (
        <div onClick={() => {
            if (!props.disabled) {
                setOpen(v => !v)
            }
        }} ref={ref} className={selectorContainerClassName}>
            <div className={inputClassName}>
                <span className={selectedClassName}>{props.value}</span>
                <FontAwesome ariaHidden={false} name={"fa-angle-down"} prefix={'fas'}/>
            </div>
            {open && <div className={styles.dropdownContainer}>
                {options}
            </div>}
        </div>
    );
}